<template>
  <div class="d-flex flex-column">
    <span class="statement-label">Extrato</span>
    <span v-if="!history || history.length <= 0"> Não há histórico de cashback para o período selecionado</span>

    <div v-else>
      <v-data-table v-if="!isMobile" :headers="headers" :items="history" disable-sort mobile-breakpoint="0">
        <template v-slot:header.date="{ header }">
          <span class="cashback-history-table-header">{{ header.text }}</span>
        </template>

        <template v-slot:header.value="{ header }">
          <span class="cashback-history-table-header">{{ header.text }}</span>
        </template>

        <template v-slot:item.date="{ item }">
          <span class="cinza-0-text">{{ formatDate(item.date) }}</span>
        </template>

        <template v-slot:item.value="{ item }">
          <div class="d-flex flex-row align-center" style="gap: 4px">
            <div v-if="isCredit(item.transactionType)" class="icon-container bg-verde-0">
              <mf-icon fill color="white" small>add</mf-icon>
            </div>
            <div v-else-if="isDebit(item.transactionType)" class="icon-container bg-vermelho-0">
              <mf-icon fill color="white" small>remove</mf-icon>
            </div>
            <span :class="isCredit(item.transactionType) ? 'verde-0-text' : 'vermelho-d20-text'">
              R${{ localeString(item.value || 0, 2) }}
              <span v-if="item.adjustmentReason" class="cinza-0-text" style="font-weight: normal">
                | Ajuste realizado manualmente. Motivo: {{ item.adjustmentReason }}
              </span>
            </span>
          </div>
        </template>
      </v-data-table>

      <div v-else class="history-container mt-3">
        <div v-for="(item, index) in history" :key="index" class="history-item">
          <div class="d-flex flex-row justify-space-between">
            <div class="d-flex flex-column">
              <span style="font-weight: bold">Data</span>
              <span class="cinza-0-text">{{ formatDate(item.date) }}</span>
            </div>

            <div class="d-flex flex-column align-end">
              <span style="font-weight: bold">Cashback {{ item.adjustmentReason ? item.adjustmentReason : '' }}</span>
              <div class="d-flex flex-row align-center" style="gap: 4px">
                <div v-if="isCredit(item.transactionType)" class="icon-container bg-verde-0">
                  <mf-icon fill color="white" small>add</mf-icon>
                </div>
                <div v-else-if="isDebit(item.transactionType)" class="icon-container bg-vermelho-0">
                  <mf-icon fill color="white" small>remove</mf-icon>
                </div>
                <span :class="isCredit(item.transactionType) ? 'verde-0-text' : 'vermelho-d20-text'"> R${{ localeString(item.value || 0, 2) }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'CashbackHistoryTable',
  props: {
    history: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Data',
          align: 'start',
          width: '50%',
          value: 'date',
        },
        {
          text: 'Cashback',
          align: 'start',
          width: '50%',
          value: 'value',
        },
      ]
    },
  },
  methods: {
    localeString,
    formatDate(date) {
      return DateTime.fromISO(date).toFormat('dd/MM/yyyy - HH:mm')
    },
    isDebit(transactionType) {
      return transactionType === 'debit'
    },
    isCredit(transactionType) {
      return transactionType === 'credit'
    },
  },
}
</script>

<style lang="scss" scoped>
.statement-label {
  font-size: 16px;
  font-weight: 700;
  color: $cinza-d10;
}

.history-container {
  background-color: $cinza-l90;
  padding: 8px 8px 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid $cinza-l80;
}

.history-item {
  padding: 6px 4px;
  border-bottom: 1px solid $cinza-l80;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  height: 22px;
  width: 22px;
}

.cashback-history-table-header {
  font-size: 14px;
  font-weight: 700;
  color: $cinza-d20;
}

.bg-verde-0 {
  background-color: $verde-0;
}

.bg-vermelho-0 {
  background-color: $vermelho-0;
}

.verde-0-text {
  color: $verde-0;
}

.vermelho-d20-text {
  color: $vermelho-d20;
}

.cinza-0-text {
  color: $cinza-0;
}
</style>
